import { render, staticRenderFns } from "./jdwshy.vue?vue&type=template&id=1198c9be&scoped=true"
import script from "./jdwshy.vue?vue&type=script&lang=js"
export * from "./jdwshy.vue?vue&type=script&lang=js"
import style0 from "./jdwshy.vue?vue&type=style&index=0&id=1198c9be&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198c9be",
  null
  
)

export default component.exports